import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  IoDocumentTextOutline, 
  IoSearch, 
  IoCloseCircle, 
  IoCalendarOutline, 
  IoPersonOutline, 
  IoTrashOutline, 
  IoEyeOutline, 
  IoDownloadOutline,
  IoDocumentOutline
} from 'react-icons/io5';

// Web Storage wrapper (using localStorage)
const storage = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      //console.error('Error getting item from localStorage:', error);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      //console.error('Error setting item in localStorage:', error);
    }
  },
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      //console.error('Error removing item from localStorage:', error);
    }
  }
};

// Função para formatar data
const formatarData = (dataString) => {
  if (!dataString) return 'Data não informada';
  try {
    const data = new Date(dataString);
    return data.toLocaleDateString('pt-BR');
  } catch (error) {
    //console.error('Erro ao formatar data:', error);
    return dataString;
  }
};

// Styles
const styles = {
  mainContainer: {
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    flexDirection: 'column',
  },
  scrollContainer: {
    flex: 1,
    padding: '16px',
    maxWidth: '800px',
    margin: '0 auto',
    width: '100%',
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px',
    minHeight: '400px',
  },
  loadingSpinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #137a7f',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  loadingText: {
    marginTop: '16px',
    fontSize: '16px',
    color: '#666',
    textAlign: 'center',
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: '12px',
    paddingHorizontal: '16px',
    marginBottom: '20px',
    borderWidth: '1px',
    borderColor: '#ddd',
    borderStyle: 'solid',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  searchIcon: {
    marginRight: '12px',
    fontSize: '20px',
    color: '#999',
  },
  input: {
    flex: 1,
    height: '50px',
    fontSize: '16px',
    color: '#333',
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
  },
  clearButton: {
    padding: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'none',
    border: 'none',
  },
  clearIcon: {
    fontSize: '20px',
    color: '#999',
  },
  resultsCount: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '16px',
    textAlign: 'center',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    marginBottom: '16px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    borderWidth: '1px',
    borderColor: '#e0e0e0',
    borderStyle: 'solid',
    overflow: 'hidden',
  },
  cardContentArea: {
    padding: '20px',
    cursor: 'pointer',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
  },
  headerIcon: {
    fontSize: '24px',
    color: '#137a7f',
    marginRight: '12px',
  },
  pedidoText: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#137a7f',
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  infoRow: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  infoIcon: {
    marginTop: '2px',
    marginRight: '12px',
    fontSize: '18px',
    color: '#666',
  },
  infoText: {
    flex: 1,
  },
  label: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#999',
    marginBottom: '2px',
    textTransform: 'uppercase',
  },
  value: {
    fontSize: '16px',
    color: '#333',
    lineHeight: '22px',
  },
  cardFooter: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px',
    backgroundColor: '#f8f9fa',
    borderTopWidth: '1px',
    borderTopColor: '#f0f0f0',
    borderTopStyle: 'solid',
  },
  footerButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'center',
  },
  deleteButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
    backgroundColor: 'transparent',
    borderRadius: '8px',
    flex: 1,
    maxWidth: '50%',
    cursor: 'pointer',
    border: 'none',
  },
  downloadButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
    backgroundColor: 'transparent',
    borderRadius: '8px',
    flex: 1,
    maxWidth: '50%',
    cursor: 'pointer',
    border: 'none',
  },
  viewReportText: {
    fontSize: '14px',
    color: '#137a7f',
    fontWeight: '500',
    marginRight: '8px',
  },
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
  },
  emptyIcon: {
    fontSize: '64px',
    color: '#ccc',
  },
  emptyText: {
    fontSize: '16px',
    color: '#666',
    textAlign: 'center',
    marginTop: '16px',
  },
  emptySubText: {
    fontSize: '14px',
    color: '#666',
    textAlign: 'center',
    marginTop: '8px',
  },
  divider: {
    width: '1px',
    height: '80%',
    backgroundColor: '#e0e0e0',
    marginHorizontal: '8px',
  },
  navbar: {
    backgroundColor: '#137a7f',
    padding: '16px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  navbarTitle: {
    color: 'white',
    fontSize: '18px',
    fontWeight: '600',
    margin: 0,
  },
  backButton: {
    position: 'absolute',
    left: '20px',
    background: 'none',
    border: 'none',
    color: 'white',
    fontSize: '20px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  backButtonText: {
    fontSize: '14px',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: '15px',
    padding: '20px',
    width: '90%',
    maxWidth: '400px',
  },
  modalTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#137a7f',
    marginBottom: '20px',
    textAlign: 'center',
  },
  modalButtons: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
    marginTop: '20px',
  },
  modalButton: {
    padding: '10px 20px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
  },
  modalButtonCancel: {
    backgroundColor: '#f0f0f0',
    color: '#666',
  },
  modalButtonConfirm: {
    backgroundColor: '#137a7f',
    color: 'white',
  },
  modalButtonDelete: {
    backgroundColor: '#e74c3c',
    color: 'white',
  },
};

// Add keyframes animation
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);

// NavBar Component
const NavBar = ({ title, showBackButton = false }) => {
  const navigate = useNavigate();

  return (
    <div style={styles.navbar}>
      {showBackButton && (
        <button
          onClick={() => navigate(-1)}
          style={styles.backButton}
        >
          ← <span style={styles.backButtonText}>Voltar</span>
        </button>
      )}
      <h1 style={styles.navbarTitle}>{title}</h1>
    </div>
  );
};

// Modal Component
const ConfirmModal = ({ visible, title, message, onConfirm, onCancel, confirmText = "Confirmar", isDelete = false }) => {
  if (!visible) return null;

  return (
    <div style={styles.modalOverlay} onClick={onCancel}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3 style={styles.modalTitle}>{title}</h3>
        <p style={{ textAlign: 'center', marginBottom: '20px' }}>{message}</p>
        <div style={styles.modalButtons}>
          <button
            style={{ ...styles.modalButton, ...styles.modalButtonCancel }}
            onClick={onCancel}
          >
            Cancelar
          </button>
          <button
            style={{ ...styles.modalButton, ...(isDelete ? styles.modalButtonDelete : styles.modalButtonConfirm) }}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default function ExamesScreen() {
  const [exames, setExames] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [downloadedReports, setDownloadedReports] = useState({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedExame, setSelectedExame] = useState(null);
  const [modalAction, setModalAction] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const storedPesCod = storage.getItem('cpf');
        const storedLink = storage.getItem('link');
        const storedChave = storage.getItem('chave');
        const storedGuid = storage.getItem('govbr_guid');
        const guidParam = storedGuid ? `&GUID=${storedGuid}` : '';

        if (!guidParam) {
          setLoading(false);
          return;
        }

        const url = `${storedLink}/apidadospaciente.rule?sys=SAU&p1=${storedChave}&p2=exames&p10=${storedPesCod}${guidParam}`;
        //console.log('URL da API (exames):', url);
        
        const response = await fetch(url);
        const data = await response.json();

        //console.log('Resposta da API (exames):', data);

        if (data.status === "success" && data.dados && data.dados.length > 0) {
          setExames(data.dados);
        } else {
          //console.log('API não retornou exames válidos');
          setExames([]);
        }
      } catch (error) {
        //console.log('Erro ao buscar exames:', error);
        setExames([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Função para verificar quais relatórios já foram baixados
  const checkDownloadedReports = async () => {
    try {
      const storedReports = {};

      for (const item of exames) {
        if (item.PED_COD) {
          const fileData = storage.getItem(item.PED_COD);
          storedReports[item.PED_COD] = !!fileData;
        } else {
          storedReports[item.PED_COD] = false;
        }
      }

      setDownloadedReports(storedReports);
    } catch (error) {
      //console.error("Erro ao verificar relatórios baixados:", error);
    }
  };

  // Verificar relatórios baixados quando a lista de exames mudar
  useEffect(() => {
    if (exames.length > 0) {
      checkDownloadedReports();
    }
  }, [exames]);

  // Função para verificar se há dados
  const hasAnyData = () => {
    return Array.isArray(exames) && exames.length > 0;
  };

  const examesFiltrados = exames.filter((item) => {
    const searchText = filtro.toLowerCase();
    const matchesSearch =
      item.PED_COD?.toLowerCase().includes(searchText) ||
      item.data?.toLowerCase().includes(searchText) ||
      item.Solicitante?.toLowerCase().includes(searchText);

    return matchesSearch;
  });

  const downloadAndOpenPdf = async (item) => {
    setDownloading(item.PED_COD);

    try {
      const storedLink = storage.getItem('link');
      const storedChave = storage.getItem('chave');
      const response = await fetch(
        `${storedLink}/apidadospaciente.rule?sys=SAU&p1=${storedChave}&p2=resultado&p3=&p4=${item.PED_COD}`
      );
      const data = await response.json();

      if (data.link) {
        setSelectedExame(item);
        setModalAction('download');
        setShowConfirmModal(true);
      } else {
        alert('Relatório não disponível para este exame.');
        setDownloading(null);
      }
    } catch (error) {
      alert('Falha ao acessar o relatório.');
      setDownloading(null);
    }
  };

  const confirmDownload = async () => {
    setShowConfirmModal(false);
    const item = selectedExame;

    try {
      const storedLink = storage.getItem('link');
      const storedChave = storage.getItem('chave');
      const response = await fetch(
        `${storedLink}/apidadospaciente.rule?sys=SAU&p1=${storedChave}&p2=resultado&p3=&p4=${item.PED_COD}`
      );
      const data = await response.json();

      if (data.link) {
        // Baixar o PDF
        const pdfResponse = await fetch(data.link);
        const pdfBlob = await pdfResponse.blob();

        // Criar URL para download
        const url = window.URL.createObjectURL(pdfBlob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `relatorio_${item.PED_COD}_${Date.now()}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        // Salvar referência no localStorage
        storage.setItem(item.PED_COD, 'downloaded');

        // Atualizar o estado
        setDownloadedReports(prev => ({
          ...prev,
          [item.PED_COD]: true
        }));

        // Abrir o PDF em nova aba
        window.open(data.link, '_blank');
      }
    } catch (error) {
      alert('Não foi possível baixar o relatório.');
    } finally {
      setDownloading(null);
      setSelectedExame(null);
    }
  };

  const handleDeleteReport = async (item) => {
    setSelectedExame(item);
    setModalAction('delete');
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setShowDeleteModal(false);
    const item = selectedExame;

    try {
      // Remover a referência do localStorage
      storage.removeItem(item.PED_COD);

      // Atualizar o estado
      setDownloadedReports(prev => ({
        ...prev,
        [item.PED_COD]: false
      }));

      alert('Relatório excluído com sucesso.');
    } catch (error) {
      alert('Não foi possível excluir o relatório.');
    } finally {
      setDeleting(null);
      setSelectedExame(null);
    }
  };

  const handleCardPress = (item) => {
    // Apenas mostra informações ao clicar no card
    //console.log('Card clicked:', item);
  };

  const handleDownloadPress = async (item) => {
    if (downloadedReports[item.PED_COD]) {
      // Se já foi baixado, tentar abrir
      try {
        const storedLink = storage.getItem('link');
        const storedChave = storage.getItem('chave');
        const response = await fetch(
          `${storedLink}/apidadospaciente.rule?sys=SAU&p1=${storedChave}&p2=resultado&p3=&p4=${item.PED_COD}`
        );
        const data = await response.json();

        if (data.link) {
          window.open(data.link, '_blank');
        } else {
          alert('Relatório não disponível.');
        }
      } catch (error) {
        alert('Não foi possível abrir o relatório.');
      }
    } else {
      // Se não foi baixado, fazer o download
      await downloadAndOpenPdf(item);
    }
  };

  const getButtonText = (pedCod) => {
    if (downloading === pedCod) {
      return "Baixando...";
    }
    return downloadedReports[pedCod] ? "Abrir relatório" : "Baixar relatório";
  };

  return (
    <div style={styles.mainContainer}>
      <NavBar title="Exames" showBackButton={true} />

      <div style={styles.scrollContainer}>
        {loading ? (
          <div style={styles.loadingContainer}>
            <div style={styles.loadingSpinner} />
            <div style={styles.loadingText}>Carregando exames...</div>
          </div>
        ) : !hasAnyData() ? (
          <div style={styles.emptyContainer}>
            <IoDocumentOutline style={styles.emptyIcon} />
            <div style={styles.emptyText}>Nenhum exame encontrado</div>
            <div style={styles.emptySubText}>
              Consulte a Unidade de Saúde para verificar seus exames.
            </div>
          </div>
        ) : (
          <>
            <div style={styles.searchContainer}>
              <IoSearch style={styles.searchIcon} />
              <input
                type="text"
                style={styles.input}
                placeholder="Pesquisar por pedido, data ou solicitante..."
                value={filtro}
                onChange={(e) => setFiltro(e.target.value)}
              />
              {filtro.length > 0 && (
                <button
                  onClick={() => setFiltro('')}
                  style={styles.clearButton}
                >
                  <IoCloseCircle style={styles.clearIcon} />
                </button>
              )}
            </div>

            <div style={styles.resultsCount}>
              {examesFiltrados.length} exame
              {examesFiltrados.length !== 1 ? "s" : ""} encontrado
              {examesFiltrados.length !== 1 ? "s" : ""}
            </div>

            {examesFiltrados.length > 0 ? (
              examesFiltrados.map((item, index) => (
                <div key={index} style={styles.card}>
                  <div
                    onClick={() => handleCardPress(item)}
                    style={styles.cardContentArea}
                  >
                    <div style={styles.cardHeader}>
                      <IoDocumentTextOutline style={styles.headerIcon} />
                      <div style={styles.pedidoText}>
                        Pedido: {item.PED_COD || "Não informado"}
                      </div>
                    </div>

                    <div style={styles.cardContent}>
                      <div style={styles.infoRow}>
                        <IoCalendarOutline style={styles.infoIcon} />
                        <div style={styles.infoText}>
                          <div style={styles.label}>Data</div>
                          <div style={styles.value}>
                            {formatarData(item.data)}
                          </div>
                        </div>
                      </div>

                      <div style={styles.infoRow}>
                        <IoPersonOutline style={styles.infoIcon} />
                        <div style={styles.infoText}>
                          <div style={styles.label}>Solicitante</div>
                          <div style={styles.value}>
                            {item.Solicitante || "Não informado"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={styles.cardFooter}>
                    {downloadedReports[item.PED_COD] && (
                      <>
                        <button
                          onClick={() => handleDeleteReport(item)}
                          style={styles.deleteButton}
                          disabled={deleting === item.PED_COD}
                        >
                          {deleting === item.PED_COD ? (
                            <div style={styles.loadingSpinner} />
                          ) : (
                            <IoTrashOutline size={20} color="#dc3545" />
                          )}
                        </button>
                        <div style={styles.divider} />
                      </>
                    )}

                    <button
                      onClick={() => handleDownloadPress(item)}
                      style={styles.downloadButton}
                      disabled={downloading === item.PED_COD}
                    >
                      {downloading === item.PED_COD ? (
                        <div style={styles.loadingSpinner} />
                      ) : (
                        <>
                          <span style={styles.viewReportText}>
                            {getButtonText(item.PED_COD)}
                          </span>
                          {downloadedReports[item.PED_COD] ? (
                            <IoEyeOutline size={20} color="#137a7f" />
                          ) : (
                            <IoDownloadOutline size={20} color="#137a7f" />
                          )}
                        </>
                      )}
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div style={styles.emptyContainer}>
                <IoDocumentOutline style={styles.emptyIcon} />
                <div style={styles.emptyText}>
                  {filtro
                    ? "Nenhum exame encontrado para a pesquisa."
                    : "Nenhum exame encontrado."}
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <ConfirmModal
        visible={showConfirmModal}
        title="Baixar Relatório"
        message={`Deseja baixar e abrir o relatório do exame ${selectedExame?.PED_COD || ''}?`}
        onConfirm={confirmDownload}
        onCancel={() => {
          setShowConfirmModal(false);
          setDownloading(null);
          setSelectedExame(null);
        }}
        confirmText="Confirmar"
      />

      <ConfirmModal
        visible={showDeleteModal}
        title="Excluir Relatório"
        message={`Deseja excluir o relatório do exame ${selectedExame?.PED_COD || ''}?`}
        onConfirm={confirmDelete}
        onCancel={() => {
          setShowDeleteModal(false);
          setSelectedExame(null);
        }}
        confirmText="Excluir"
        isDelete={true}
      />
    </div>
  );
}